export default __webpack_public_path__ + "static/media/r9.0e2d5fcc.jpg";